import { useTranslation as e } from "../../i18n.mjs";
import { ImageBubbleMenuState as t, ImageModeEnum as n } from "./image-enum.mjs";
import { ToolbarButton as r } from "../../components/content-controls/toolbar-button.mjs";
import { BubbleMenu as ee } from "../../components/bubble-menu/BubbleMenu.mjs";
import te from "../../icons/image-centered-icon.mjs";
import ne from "../../icons/image-inline-icon.mjs";
import re from "../../icons/image-side-icon.mjs";
import { LinkBubbleEdit as i, LinkBubbleView as a } from "../link-extension/link-bubble-state.mjs";
import { isImageSelected as o } from "./utils/is-image-selected.mjs";
import { FileSelectorModal as s } from "@systemeio/file-manager";
import { useEditorState as c } from "@tiptap/react";
import { useCallback as l, useEffect as u, useRef as d, useState as f } from "react";
import { twJoin as p, twMerge as m } from "tailwind-merge";
import { Input as h } from "@systemeio/components";
import { Fragment as g, jsx as _, jsxs as v } from "react/jsx-runtime";
import { CheckIcon as y, Heading01Icon as b, Link01Icon as x, PhoneMaximizeIcon as S, TypeSquareIcon as C } from "@systemeio/icons";
//#region src/extensions/image-extension/image-bubble-menu.tsx
var w = (e) => ({
	[t.EditAltMode]: e?.alt ?? "",
	[t.EditLinkMode]: e?.href ?? "",
	[t.EditCaptionMode]: e?.caption ?? ""
}), T = (e) => e === t.EditAltMode || e === t.EditCaptionMode || e === t.EditLinkMode, E = (e, n) => e[t.EditAltMode] === n[t.EditAltMode] && e[t.EditLinkMode] === n[t.EditLinkMode] && e[t.EditCaptionMode] === n[t.EditCaptionMode], D = ({ editor: D, fileSource: O, options: ie }) => {
	let { t: k } = e(), [A, j] = f(w()), [M, N] = f(t.InitialMode), [P, F] = f(!1), [I, L] = f(!1), R = d(t.InitialMode), z = d({
		alt: null,
		href: null,
		caption: null
	}), B = c({
		editor: D,
		selector: ({ editor: e }) => {
			let t = e?.state, n = t?.selection.from, r = t?.doc.nodeAt(n ?? 0)?.type.name;
			return {
				from: n,
				node: r,
				imageMode: r ? e?.getAttributes(r).imageMode : null,
				isMobileFullWidth: r ? e?.getAttributes(r).isMobileFullWidth : !1,
				alt: r ? e?.getAttributes(r).alt : null,
				href: r ? e?.getAttributes(r).href : null,
				caption: r ? e?.getAttributes(r).caption : null
			};
		}
	}), V = B?.from, H = B?.node, U = B?.imageMode ?? null, W = B?.isMobileFullWidth ?? !1, G = B?.alt ?? null, K = B?.href ?? null, q = B?.caption ?? null;
	u(() => {
		R.current = M;
	}, [M]), u(() => {
		z.current = {
			alt: G,
			href: K,
			caption: q
		};
	}, [
		G,
		K,
		q
	]);
	let J = l((e) => {
		j((t) => E(t, e) ? t : e);
	}, []);
	u(() => {
		N(t.InitialMode);
		let e = w(z.current);
		J(e);
	}, [V, J]), u(() => {
		let e = w({
			alt: G,
			href: K,
			caption: q
		});
		J(e);
	}, [
		G,
		K,
		q,
		J
	]);
	let Y = l((e) => H ? (D?.chain().focus().updateAttributes(H, e).run(), !0) : !1, [D, H]), X = l((e) => {
		D?.chain().focus().toggleImageMode(e).run();
	}, [D]);
	if (!D || !D?.options.editable) return null;
	let ae = (e, t) => {
		j((n) => ({
			...n,
			[e]: t
		}));
	}, Z = (e, n) => {
		e !== t.InitialMode && e !== t.ViewLinkMode && Y({ [e]: n }) && N(t.InitialMode);
	}, oe = (e) => {
		Y({ [e]: null }) && N(t.InitialMode);
	}, se = () => {
		U === n.Inline && X(n.BlockCenter), setTimeout(() => {
			N(t.EditCaptionMode);
		}, 0);
	}, Q = () => {
		Y({ isMobileFullWidth: !W });
	}, ce = (e) => {
		switch (e) {
			case t.EditAltMode: return z.current.alt ?? "";
			case t.EditCaptionMode: return z.current.caption ?? "";
			case t.EditLinkMode: return z.current.href ?? "";
			default: return "";
		}
	}, $ = I ? null : void 0, le = () => {
		switch (M) {
			case t.ViewLinkMode: return /* @__PURE__ */ _(a, {
				href: A[t.EditLinkMode],
				unsetLink: () => oe(t.EditLinkMode),
				setIsEditing: () => N(t.EditLinkMode)
			});
			case t.EditLinkMode: return /* @__PURE__ */ _(i, {
				initialValue: A[t.EditLinkMode],
				onSaveLink: (e) => Z(t.EditLinkMode, e),
				openFileSelector: () => {
					F(!0);
				},
				schemeOptions: ie?.schemeOptions
			}, A[t.EditLinkMode]);
			case t.EditCaptionMode:
			case t.EditAltMode: {
				let e = A[M], n = "";
				switch (M) {
					case t.EditCaptionMode:
						n = k("caption");
						break;
					case t.EditAltMode: n = k("alt_text");
				}
				return /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(h, {
					placeholder: n,
					value: e,
					onChange: (e) => ae(M, e.target.value)
				}), /* @__PURE__ */ _(r, {
					label: k("global.apply"),
					onClick: () => Z(M, e),
					type: "submit",
					children: /* @__PURE__ */ _(y, {})
				})] });
			}
			case t.InitialMode:
			default: return /* @__PURE__ */ v(g, { children: [
				/* @__PURE__ */ _(r, {
					active: U === n.Inline,
					label: k("image_in_line"),
					onClick: () => X(n.Inline),
					tooltip: $,
					children: /* @__PURE__ */ _(ne, {})
				}),
				/* @__PURE__ */ _(r, {
					active: U === n.BlockCenter,
					label: k("image_center"),
					onClick: () => X(n.BlockCenter),
					tooltip: $,
					children: /* @__PURE__ */ _(te, {})
				}),
				/* @__PURE__ */ _(r, {
					active: U === n.BlockRight,
					label: k("image_side"),
					onClick: () => X(n.BlockRight),
					tooltip: $,
					children: /* @__PURE__ */ _(re, {})
				}),
				/* @__PURE__ */ _(r, {
					active: !!G,
					label: k("image_change_alt_text"),
					onClick: () => N(t.EditAltMode),
					tooltip: $,
					children: /* @__PURE__ */ _(b, {})
				}),
				/* @__PURE__ */ _(r, {
					active: !!q,
					label: k("image_change_caption"),
					onClick: se,
					tooltip: $,
					children: /* @__PURE__ */ _(C, {})
				}),
				/* @__PURE__ */ _(r, {
					active: !!K,
					label: k("image_change_link"),
					onClick: () => N(K ? t.ViewLinkMode : t.EditLinkMode),
					tooltip: $,
					children: /* @__PURE__ */ _(x, {})
				}),
				/* @__PURE__ */ _(r, {
					active: W,
					label: k("image_change_mobile_full_width"),
					onClick: Q,
					tooltip: $,
					children: /* @__PURE__ */ _(S, {})
				})
			] });
		}
	}, ue = (e) => {
		if (T(e)) {
			let t = ce(e);
			j((n) => ({
				...n,
				[e]: t
			}));
		}
	};
	return /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(ee, {
		className: p(P && "hidden"),
		editor: D,
		pluginKey: "imageBubbleMenu",
		options: {
			onHide: () => {
				let e = R.current;
				ue(e), N(t.InitialMode), L(!0);
			},
			onShow: () => {
				L(!1);
			}
		},
		shouldShow: ({ editor: e }) => o(e),
		children: /* @__PURE__ */ _("form", {
			onSubmit: (e) => e.preventDefault(),
			className: m("flex items-center p-2", M === t.InitialMode && "gap-0.5"),
			children: le()
		})
	}), /* @__PURE__ */ _(s, {
		uploadingFromSource: O,
		initialSearchFilters: {
			source: [O],
			name: "",
			type: []
		},
		opened: P,
		onClose: () => F(!1),
		onSelect: (e) => {
			Z(t.EditLinkMode, e.path), F(!1);
		}
	})] });
};
//#endregion
export { D as ImageBubbleMenu };
